var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "upload-file" },
    [
      _c(
        "el-upload",
        {
          ref: "upload",
          staticClass: "upload-file-uploader",
          attrs: {
            action: _vm.uploadFileUrl,
            "before-upload": _vm.handleBeforeUpload,
            "file-list": _vm.fileList,
            limit: _vm.limit,
            headers: _vm.headers,
            multiple: _vm.multiple,
            name: "files",
            "on-exceed": _vm.handleExceed,
            "on-error": _vm.handleUploadError,
            "on-success": _vm.handleUploadSuccess,
            "show-file-list": false,
          },
        },
        [
          _vm.showOtherStyle
            ? _vm._t("default")
            : _c(
                "el-button",
                { attrs: { size: "", plain: "", type: "primary" } },
                [_vm._v(_vm._s(_vm.btnText))]
              ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }